import { Nav } from "@/components/Nav";
import { Lookbook } from "@/components/Lookbook";
import { Footer } from "@/components/Footer";

export default function LookbookPage() {
  return (
    <main className="pt-24" data-testid="lookbook-page">
      <Nav />
      <Lookbook />
      <Footer />
    </main>
  );
}
